export const EVENTS_LIST = "EVENTS_LIST";
export const EVENT_DETAILS = "EVENT_DETAILS";
export const LOADING_STATE = "LOADING_STATE";
export const HOST_LIST = "HOST_LIST";
export const EVENT_FILTER = "EVENT_FILTER";
export const SET_FILTERS_OPTIONS = "SET_FILTERS_OPTIONS";
export const SET_FILTERS_SEARCH_OPTIONS = "SET_FILTERS_SEARCH_OPTIONS";
